import React, { createContext, useState } from "react";
export const SectorContext = createContext();

const SectorProvider = ({ children }) => {
  const [client, setClient] = useState();

  const configFilter = (data) => {
    if (data !== client) {
      setClient(data);
    }
  };

  return (
    <SectorContext.Provider value={{ client, configFilter }}>
      {children}
    </SectorContext.Provider>
  );
};

export { SectorProvider };
